import { config } from "../config";
export function getNumberFormatter(options) {
    const params = Object.assign(Object.assign({}, config.get.defaultSettingsValues.numberFormat), options);
    return new Intl.NumberFormat(config.get.locale, params);
}
export function getDateTimeFormatter(options) {
    return new Intl.DateTimeFormat(config.get.locale, options);
}
export function getMoneyFormat(options) {
    const params = Object.assign(Object.assign({}, config.get.defaultSettingsValues.moneyFormat), options);
    return new Intl.NumberFormat(config.get.locale, params);
}
export function getPointsFormat(options) {
    const params = Object.assign(Object.assign({}, config.get.defaultSettingsValues.pointsFormat), options);
    return new Intl.NumberFormat(config.get.locale, params);
}
export function getDecimalSeparator() {
    const numberWithDecimalSeparator = 1.1;
    const separator = new Intl.NumberFormat(config.get.locale)
        .formatToParts(numberWithDecimalSeparator)
        .find(part => part.type === "decimal");
    return separator.value;
}
export function getGroupSeparator() {
    const numberWithGroupSeparator = 1000;
    const separator = new Intl.NumberFormat(config.get.locale)
        .formatToParts(numberWithGroupSeparator)
        .find(part => part.type === "group");
    return separator.value;
}
//# sourceMappingURL=localizationApi.js.map